import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  SelectProps,
} from "antd";
import { CustomDropdownSelect, DatePicker } from "../../../../../../components";
import { AiOutlineMinusCircle } from "react-icons/ai";
import { Button as BootstrapButton } from "react-bootstrap";
import {
  getSubjectOptions,
  getMajorOptions,
} from "../../../summary-employee-request/utils/get-emajor";
import { useMemo } from "react";
import {
  courseOptions,
  educationTypeOptions,
} from "../../../../../../constants";
import _ from "lodash";

interface CreateCourseFormProps {
  onSubmit: (values: any) => void;
  course: any;
  hiddenFields?: string[];
  disabledFields?: string[];
}

// const initialValues = {
//   eTrainees: [],
//   eLessonTypes: [],
//   eCoursePlaces: [],
//   eDepartment: null,
//   eTrainingCourse: null,
//   eMajor: null,
//   eSubject: null,
//   eTrainingType: null,
//   eTraineeObject: "",
//   eDateTime: null,
//   eNotes: "",
// };

export const CreateCourseForm = (props: Partial<CreateCourseFormProps>) => {
  const {
    onSubmit = () => {},
    course,
    hiddenFields = [],
    disabledFields = [],
  } = props;
  const [form] = Form.useForm();

  const eTrainees = Form.useWatch("eTrainees", form);
  const eLessonTypes = Form.useWatch("eLessonTypes", form);
  const eCoursePlaces = Form.useWatch("eCoursePlaces", form);
  const eMajor = Form.useWatch("eMajor", form);

  const onFinish = (values: any) => {
    const formValues = _.omit(values, [
      "checkETrainees",
      "checkELessonTypes",
      "checkECoursePlaces",
    ]);
    onSubmit({ ...(course ?? {}), ...formValues });
  };

  const getFormListOptions = (
    options: Required<SelectProps["options"]> = [],
    valueField: string
  ) => {
    const fieldValue: any[] = form.getFieldValue(valueField) || [];
    const mappedFieldValue = fieldValue
      .filter((e) => Boolean(e))
      .map((e) => e.label);

    const remainOptions = options.filter(
      (e) => !mappedFieldValue.includes(e.value)
    );
    return remainOptions;
  };

  const majorOptions = getMajorOptions();
  const subjectOptions = useMemo(() => {
    if (!eMajor) return [];
    return getSubjectOptions(eMajor) || [];
  }, [eMajor]);
  return (
    <Form
      name="dynamic_form_nest_item"
      autoComplete="off"
      form={form}
      size="large"
      layout="vertical"
      onFinish={onFinish}
      initialValues={course}
    >
      <Row gutter={[32, 0]}>
        {!hiddenFields.includes("eCourseTrainee") && (
          <Col span={12}>
            <Form.Item
              label="Giáo viên/Đối tác"
              name="eCourseTrainee"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn trường này!",
                },
              ]}
            >
              <Input disabled={disabledFields.includes("eCourseTrainee")} />
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eTrainingCourse") && (
          <Col span={12}>
            <Form.Item
              label="Khoá đào tạo"
              name="eTrainingCourse"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn trường này!",
                },
              ]}
            >
              <CustomDropdownSelect
                disabled={disabledFields.includes("eTrainingCourse")}
                options={courseOptions}
                className="min-w-full"
                addInputPlaceholder="Nhập khoá đào tạo"
                addButtonText="+ Thêm khoá đào tạo"
              />
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eLessonTypes") && (
          <Col span={12}>
            <Form.Item
              name="checkELessonTypes"
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (
                      (getFieldValue("eLessonTypes") &&
                        getFieldValue("eLessonTypes").length) ||
                      disabledFields.includes("eLessonTypes")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Vui lòng thêm loại hình tiết học!");
                  },
                }),
              ]}
            >
              <Form.List name="eLessonTypes">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => {
                      const lessonTypeOptions = getFormListOptions(
                        [
                          { label: "EL", value: "EL" },
                          { label: "TT", value: "TT" },
                          { label: "TH", value: "TH" },
                        ],
                        "eLessonTypes"
                      );
                      return (
                        <Row key={key} gutter={[12, 0]}>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              label="Loại hình tiết học"
                              name={[name, "label"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng chọn trường này!",
                                },
                              ]}
                            >
                              <Select
                                disabled={disabledFields.includes(
                                  "eLessonTypes"
                                )}
                                options={lessonTypeOptions}
                                className="min-w-full"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            <Form.Item
                              {...restField}
                              label="Thời lượng"
                              name={[name, "value"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng nhập trường này!",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={disabledFields.includes(
                                  "eLessonTypes"
                                )}
                                min={1}
                                className="min-w-full"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={2}>
                            {!disabledFields.includes("eLessonTypes") && (
                              <div className="flex-center h-full cursor-pointer">
                                <AiOutlineMinusCircle
                                  size={22}
                                  onClick={() => remove(name)}
                                />
                              </div>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                    {eLessonTypes?.length !== 3 && (
                      <Button
                        disabled={disabledFields.includes("eLessonTypes")}
                        type="dashed"
                        size="middle"
                        onClick={() => add()}
                        block
                      >
                        + Thêm loại hình tiết học
                      </Button>
                    )}
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eMajor") && (
          <Col span={12}>
            <Form.Item
              label="Nghiệp vụ"
              name="eMajor"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn trường này!",
                },
              ]}
            >
              <CustomDropdownSelect
                disabled={disabledFields.includes("eMajor")}
                options={majorOptions}
                className="min-w-full"
                addInputPlaceholder="Nhập nghiệp vụ"
                addButtonText="+ Thêm nghiệp vụ"
              />
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eTrainees") && (
          <Col span={12}>
            <Form.Item
              name="checkETrainees"
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (
                      (getFieldValue("eTrainees") &&
                        getFieldValue("eTrainees").length) ||
                      disabledFields.includes("eTrainees")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Vui lòng thêm học viên!");
                  },
                }),
              ]}
            >
              <Form.List name="eTrainees">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => {
                      const traineeOptions = getFormListOptions(
                        [
                          { label: "VIAGS", value: "VIAGS" },
                          { label: "VNA", value: "VNA" },
                        ],
                        "eTrainees"
                      );
                      return (
                        <Row key={key} gutter={[12, 0]}>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              label="Học viên"
                              name={[name, "label"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng chọn trường này!",
                                },
                              ]}
                            >
                              <Select
                                disabled={disabledFields.includes("eTrainees")}
                                options={traineeOptions}
                                className="min-w-full"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            <Form.Item
                              {...restField}
                              label="Số lượng"
                              name={[name, "value"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng nhập trường này!",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={disabledFields.includes("eTrainees")}
                                min={1}
                                className="min-w-full"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={2}>
                            {!disabledFields.includes("eTrainees") && (
                              <div className="flex-center h-full cursor-pointer">
                                <AiOutlineMinusCircle
                                  size={22}
                                  onClick={() => remove(name)}
                                />
                              </div>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                    {eTrainees?.length !== 2 && (
                      <Button
                        disabled={disabledFields.includes("eTrainees")}
                        type="dashed"
                        size="middle"
                        onClick={() => add()}
                        block
                      >
                        + Thêm học viên
                      </Button>
                    )}
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eSubject") && (
          <Col span={12}>
            <Form.Item
              label="Môn học"
              name="eSubject"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn trường này!",
                },
              ]}
            >
              <CustomDropdownSelect
                disabled={disabledFields.includes("eSubject")}
                options={subjectOptions}
                className="min-w-full"
                addInputPlaceholder="Nhập môn học"
                addButtonText="+ Thêm môn học"
                addMoreOptions={Boolean(eMajor)}
              />
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eCoursePlaces") && (
          <Col span={12}>
            <Form.Item
              name="checkECoursePlaces"
              rules={[
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (
                      (getFieldValue("eCoursePlaces") &&
                        getFieldValue("eCoursePlaces").length) ||
                      disabledFields.includes("eCoursePlaces")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Vui lòng thêm địa điểm!");
                  },
                }),
              ]}
            >
              <Form.List name="eCoursePlaces">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => {
                      const coursePlaceOptions = getFormListOptions(
                        [
                          { label: "TN", value: "TN" },
                          { label: "NN", value: "NN" },
                        ],
                        "eCoursePlaces"
                      );
                      return (
                        <Row key={key} gutter={[12, 0]}>
                          <Col span={12}>
                            <Form.Item
                              {...restField}
                              label="Địa điểm"
                              name={[name, "label"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng chọn trường này!",
                                },
                              ]}
                            >
                              <Select
                                disabled={disabledFields.includes(
                                  "eCoursePlaces"
                                )}
                                options={coursePlaceOptions}
                                className="min-w-full"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            <Form.Item
                              {...restField}
                              label="Thời lượng"
                              name={[name, "value"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vui lòng nhập trường này!",
                                },
                              ]}
                            >
                              <InputNumber
                                disabled={disabledFields.includes(
                                  "eCoursePlaces"
                                )}
                                min={1}
                                className="min-w-full"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={2}>
                            {!disabledFields.includes("eCoursePlaces") && (
                              <div className="flex-center h-full cursor-pointer">
                                <AiOutlineMinusCircle
                                  size={22}
                                  onClick={() => remove(name)}
                                />
                              </div>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                    {eCoursePlaces?.length !== 2 && (
                      <Button
                        disabled={disabledFields.includes("eCoursePlaces")}
                        type="dashed"
                        size="middle"
                        onClick={() => add()}
                        block
                      >
                        + Thêm địa điểm
                      </Button>
                    )}
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
        )}

        {!hiddenFields.includes("eTrainingType") && (
          <Col span={12}>
            <Form.Item
              label="Loại hình đào tạo"
              name="eTrainingType"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn trường này!",
                },
              ]}
            >
              <CustomDropdownSelect
                disabled={disabledFields.includes("eTrainingType")}
                options={educationTypeOptions}
                className="min-w-full"
                addInputPlaceholder="Nhập loại hình đào tạo"
                addButtonText="+ Thêm loại hình đào tạo"
              />
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eTraineeObject") && (
          <Col span={12}>
            <Form.Item
              label="Đối tượng"
              name="eTraineeObject"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn trường này!",
                },
              ]}
            >
              <Input disabled={disabledFields.includes("eTraineeObject")} />
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eDateTime") && (
          <Col span={12}>
            <Form.Item
              label="Thời gian"
              name="eDateTime"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn trường này!",
                },
              ]}
            >
              <DatePicker.RangePicker
                disabled={disabledFields.includes("eDateTime")}
                className="min-w-full"
              />
            </Form.Item>
          </Col>
        )}
        {!hiddenFields.includes("eNotes") && (
          <Col span={24}>
            <Form.Item label="Ghi chú" name="eNotes">
              <Input.TextArea disabled={disabledFields.includes("eNotes")} />
            </Form.Item>
          </Col>
        )}
      </Row>
      <div className="flex-center">
        <BootstrapButton size="lg" variant="warning" type="submit">
          Xác nhận
        </BootstrapButton>
      </div>
    </Form>
  );
};
